import React from 'react';
import { Button, Col, Form, Row } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import qs from 'query-string';

import { InputField } from 'src/components/form';
import useForm, { FormValue } from './useForm';
import LocalStorage from 'src/utils/LocalStorage';
import history from 'src/libs/history';
import { PATH } from 'src/pages/category';
import { trim } from 'lodash';

const TopSearch: React.FC = () => {
  const { control, handleSubmit } = useForm();
  const { t } = useTranslation();
  const authInfo = LocalStorage.authInfo;
  const onSearch = (val) => {
    history.push({
      pathname: PATH,
      search: qs.stringify({ hanyomRan: trim(val.keyword) }),
    });
  };

  return (
    <Row className="top_search">
      <Col className="search-form" span={16}>
        <Form>
          <InputField<FormValue>
            controller={{ control, name: 'keyword' }}
            inputProps={{
              placeholder: t('top_nav.search_placeholder'),
            }}
            required
          />
        </Form>
        <Button
          type="primary"
          size="small"
          className="w-full"
          onClick={handleSubmit((val) => onSearch(val))}
        >
          <SearchOutlined />
        </Button>
      </Col>
      <Col className="account-info" span={8}>
        <p>{authInfo.smei}</p>
        <p>{`${t('top_nav.user_label')}: ${authInfo.userCd}`}</p>
      </Col>
    </Row>
  );
};

export default TopSearch;
